module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('alert-message', {
    attrs: {
      "message": _vm.message
    }
  }), _vm._v(" "), _c('alert-error', {
    attrs: {
      "errors": _vm.errors
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c5e7ec4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/alert/Compact.vue
// module id = 474
// module chunks = 1